import { useSearchParams } from 'next/navigation';
import { type ComponentProps, type ReactNode, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import DismissableCallout from '@alltrails/layout/components/DismissableCallout/DismissableCallout';
import { GTM_CAMPAIGN_PARAM } from '@/utils/constants';
import styles from './CreateInviteCallout.module.scss';

type CreateInviteCalloutProps = {
  anchor: ReactNode;
  // Lets a surface that mounts more than once opt a given instance out of anchoring the callout
  isEnabled?: boolean;
  placement?: ComponentProps<typeof DismissableCallout>['placement'];
};

const CreateInviteCallout = ({ anchor, isEnabled = true, placement = 'bottom-end' }: CreateInviteCalloutProps) => {
  const searchParams = useSearchParams();
  const [isDismissed, setIsDismissed] = useState(false);

  const hasCampaign = isEnabled && !!searchParams.get(GTM_CAMPAIGN_PARAM);

  return (
    <DismissableCallout
      // Wrapping div needed due to how usePopover works with cloning the anchor
      anchor={<div onClickCapture={() => setIsDismissed(true)}>{anchor}</div>}
      body={<FormattedMessage defaultMessage="Plan a group hike. Set the details, invite friends and collect RSVPs— all on AllTrails." />}
      className={styles.callout}
      isOpen={hasCampaign && !isDismissed}
      onDismiss={() => setIsDismissed(true)}
      placement={placement}
      theme="light"
      title={<FormattedMessage defaultMessage="Rally your trail crew!" />}
    />
  );
};

export default CreateInviteCallout;
